var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-admin-page-header",class:{
    'component-admin-page-header_no-bottom-padding': _vm.noBottomPadding,
    'component-admin-page-header_big-buttons': _vm.bigButtons,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }